<template>
    <a-button type="primary" @click="openModal">
        Create zone
    </a-button>

    <a-modal v-model:open="showModal" title="Create Zone" :maskClosable="false" @cancel="closeModal"
        @ok="handleSubmit" :confirmLoading="loading">
        <ZoneForm ref="zoneFormRef" :editData="editData" @success="handleSuccess" @cancel="closeModal" />
    </a-modal>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue';
import ZoneForm from '@/components/zone/ZoneForm.vue';
import { useZoneStore } from '@/store/modules/zone';

defineProps<{
    editData?: {
        id: number,
        name: string;
        countries: string;
        type: string;
        funnels: any[];
        distributionType: 'even' | 'customized';
    }
}>();

const showModal = ref(false);
const zoneFormRef = ref<InstanceType<typeof ZoneForm>>();
const loading = ref(false);
const zoneStore = useZoneStore()

const openModal = () => {
    showModal.value = true;
    nextTick(() => {
        zoneFormRef.value?.initForm();
    });
};

const closeModal = () => {
    showModal.value = false;
    zoneFormRef.value?.resetForm();
};

const handleSubmit = async () => {
    loading.value = true;
    try {
        await zoneFormRef.value?.submitForm();
    } finally {
        loading.value = false;
        await zoneStore.updateSaveState(false)
        await zoneStore.updateSaveState(true)
    }
};

const handleSuccess = async () => {
    closeModal();
};
</script>
